import type { VisualizationMeta } from '../visualization-schema';

export const assetsVisualizationMeta: VisualizationMeta = {
  primaryVisualization: {
    type: 'table',
    showRemediationButton: false,
    columns: [
      {
        header: 'Asset',
        group: {
          layout: 'column',
          style: {
            width: '100%',
            gap: '0.5rem',
          },
          elements: [
            {
              layout: 'row',
              style: {
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                width: '100%',
                gap: '0.5rem',
              },
              elements: [
                {
                  field: 'type',
                  columnType: 'image',
                  imageOptions: {
                    type: 'resourceType',
                  },
                },
                {
                  layout: 'column',
                  style: {
                    flex: 1,
                    minWidth: '320px',
                    gap: '0.35rem',
                  },
                  elements: [
                    {
                      field: 'name',
                      columnType: 'badge',
                      badgeOptions: {
                        tooltip: 'Open asset in cloud console',
                        href: '{{resourceURL}}',
                        isExternal: true,
                        maxWidth: 680,
                        status: 'neutral',
                      },
                    },
                    {
                      layout: 'row',
                      style: {
                        flexWrap: 'wrap',
                        gap: '0.35rem',
                      },
                      elements: [
                        {
                          field: 'type',
                          columnType: 'badge',
                          badgeOptions: {
                            tooltip: 'Asset type',
                            status: 'neutral',
                          },
                        },
                        {
                          field: 'service',
                          columnType: 'badge',
                          badgeOptions: {
                            tooltip: 'Cloud service',
                            status: 'neutral',
                          },
                        },
                        {
                          field: 'provider',
                          columnType: 'badge',
                          badgeOptions: {
                            tooltip: 'Cloud provider',
                            status: 'info',
                          },
                        },
                        {
                          field: 'riskScore',
                          columnType: 'badge',
                          badgeOptions: {
                            tooltip: 'Risk score',
                            status: 'bad',
                          },
                        },
                        {
                          field: 'isPubliclyExposed',
                          columnType: 'badge',
                          badgeOptions: {
                            tooltip: 'Public exposure',
                            status: 'warning',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              layout: 'row',
              style: {
                flexWrap: 'wrap',
                gap: '0.35rem',
              },
              elements: [
                {
                  field: 'providerAccountId',
                  columnType: 'badge',
                  badgeOptions: {
                    tooltip: 'Provider account ID',
                    status: 'neutral',
                  },
                },
                {
                  field: 'region',
                  columnType: 'badge',
                  badgeOptions: {
                    tooltip: 'Region',
                    status: 'neutral',
                  },
                },
                {
                  field: 'resourceId',
                  columnType: 'badge',
                  badgeOptions: {
                    tooltip: 'Resource ID',
                    status: 'neutral',
                    maxWidth: 320,
                  },
                },
              ],
            },
            {
              layout: 'row',
              style: {
                flexWrap: 'wrap',
                gap: '0.75rem',
              },
              elements: [
                {
                  field: 'lastObservedAt',
                  label: 'Last observed',
                  columnType: 'datetime',
                  style: {
                    color: '#334155',
                    fontSize: '0.75rem',
                  },
                  labelStyle: {
                    color: '#64748B',
                    fontSize: '0.75rem',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                  },
                },
                {
                  field: 'updatedAt',
                  label: 'Updated',
                  columnType: 'datetime',
                  style: {
                    color: '#334155',
                    fontSize: '0.75rem',
                  },
                  labelStyle: {
                    color: '#64748B',
                    fontSize: '0.75rem',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                  },
                },
              ],
            },
            {
              field: 'fullResourceName',
              label: 'Full resource name',
              columnType: 'text',
              containerStyle: {
                width: '100%',
              },
              labelStyle: {
                color: '#64748B',
                fontSize: '0.75rem',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
              },
              style: {
                color: '#475569',
                fontFamily:
                  'ui-monospace, SFMono-Regular, Monaco, "Liberation Mono", "Courier New", monospace',
                fontSize: '0.75rem',
                lineHeight: 1.5,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
              },
            },
          ],
        },
      },
    ],
    defaultSort: {
      field: 'riskScore',
      direction: 'desc',
    },
  },
};

export default assetsVisualizationMeta;
